export default "__VITE_ASSET__kjmN$793__"